<template>
  <div>
    <GlobalHeader />
    <div class="categoryHead">
      <div class="inner">
        <nav class="categoryHeadArea">
          <ul class="photobook">
            <li><router-link to="/photobook" :class="{ location: isSelected('/photobook') }">公式写真集紹介</router-link></li>
            <li><router-link to="/photobook/talkshow" :class="{ location: isSelected('/photobook/talkshow') }">発売記念オンライントークショー</router-link></li>
            <li><router-link to="/photobook/exhibition" :class="{ location: isSelected('/photobook/exhibition') }">10選2019作品プリント展示</router-link></li>
          </ul>
        </nav>
      </div><!-- /inner-->
    </div><!-- /categoryHead-->
  </div>
</template>

<script>
import GlobalHeader from './GlobalHeader'

export default {
  components: {
    GlobalHeader
  },
  methods: {
    isSelected (str) {
      if (str === '/photobook') {
        if (this.$route.path.indexOf(str) >= 0) {
          const pathList = this.$route.path.split('/')
          if (pathList && pathList.length < 3) {
            return true
          }
        }
        return false
      } else {
        return this.$route.path.indexOf(str) >= 0
      }
    }
  }
}
</script>
